import { render, staticRenderFns } from "./startFysson.vue?vue&type=template&id=6c412742&"
import script from "./startFysson.vue?vue&type=script&lang=js&"
export * from "./startFysson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports